<template>
	<div class="panel bgPanel mt1x cb h28x">
		<div class="title title-bg">
			<span :title="getLanguageStr('word1794','电站信息摘要')">{{getLanguageStr("word1794","电站信息摘要")}}</span>
			<div class="tool">
				<div class="icoSys h2x w2x curP" @click="$emit('stepTo','stationInfo')">
					<svg class="ico fSub"><use xlink:href="#more"></use></svg>
				</div>
			</div>
		</div>
		<loading v-show="isLoading"></loading>
		<div class="mt05x pb2x pl2x pr2x" v-if="JSON.stringify(basicInfo) !='{}'">
			<!-- <div class="mb1x">
				<div class="mb05x fs12x" :title="basicInfo.name">{{basicInfo.name}}</div>
				<div class="cSub" :title="basicInfo.location.address">{{basicInfo.location.address}}</div>
			</div> -->
			<ul class="viewBox lh20 textCut_E mb1x_E emptyToken_EE">
				<li v-if='this.deviceType.indexOf("plantType")!==-1'>
					<span class="pr1x" :title="$t('word728',['电站类型'])">{{$t("word728",["电站类型"])}}</span>
					<div class="fR cSub">
						<span v-if="basicInfo.type" :title="getTypeText(basicInfo.type,'plantType')">{{getTypeText(basicInfo.type,'plantType')}}</span>
						<span v-else>--</span>
					</div>
				</li>
				<li v-if='this.deviceType.indexOf("plantGridType")!==-1'>
					<span class="pr1x" :title="$t('word736',['并网类型'])">{{$t("word736",["并网类型"])}}</span>
					<div class="fR cSub">
						<span :title="getTypeText(basicInfo.gridInterconnectionType,'plantGridType')">{{getTypeText(basicInfo.gridInterconnectionType,'plantGridType')}}</span>
					</div>
				</li>
				<li v-if='this.deviceType.indexOf("installedCapacity")!==-1'>
					<span class="pr1x" :title="$t('word727',['装机容量'])">{{$t("word727",["装机容量"])}}</span>
					<div class="fR cSub">
						<span :title="convertData(basicInfo.installedCapacity,2,'k','Wp')[0]">{{convertData(basicInfo.installedCapacity,2,"k",'Wp')[0]}}</span>
					</div>
				</li>
				<!-- 分布式全额上网 -->
				<li v-if="basicInfo.gridInterconnectionType!='DISTRIBUTED_FULLY' &&basicInfo.gridInterconnectionType!='CENTRALIZED_FULLY'&& metering.theoryConsumeProportion !=null && this.deviceType.indexOf('theoryConsumeProportion')!==-1">
					<span :title="$t('word1477',['计划自发自用率'])">{{$t('word1477',['计划自发自用率'])}}</span>
					<div class="fR cSub">
					<span :title="floatFix(metering.theoryConsumeProportion,2,'%')">{{floatFix(metering.theoryConsumeProportion,2,"%")}}</span>
					</div>
				</li>
				<li v-if='this.deviceType.indexOf("startOperatingTime")!==-1'>
					<span class="pr1x" :title="getLanguageStr('word1478','投产日期')">{{getLanguageStr("word1478","投产日期")}}</span>
					<div class="fR cSub">
						<span :title="timeFormat(basicInfo.startOperatingTime,'utc','%Y/%m/%d',{offset:basicInfo.region.timezone})">{{timeFormat(basicInfo.startOperatingTime,'utc','%Y/%m/%d',{offset:basicInfo.region.timezone})}}</span>
					</div>
				</li>
				<li v-if='this.deviceType.indexOf("startOperatingStatus")!==-1'>
					<span class="pr1x" :title="getLanguageStr('word1711','投产状态')">{{getLanguageStr("word1711","投产状态")}}</span>
					<div class="fR cSub">
						<span v-if="Number(timeFormat(basicInfo.startOperatingTime,'utc','%Y%m%d',{offset:basicInfo.region.timezone}))<=Number(timeFormat(new Date(),'utc','%Y%m%d',{offset:basicInfo.region.timezone}))">{{getLanguageStr('word1491','已投产')}}</span>
						<span v-else>{{getLanguageStr('word1492','未投产')}}</span>
					</div>
				</li>
				<li v-if='this.deviceType.indexOf("contactPhone")!==-1'>
				   <span class="pr1x" :title="getLanguageStr('word1617','业主联系电话')">{{getLanguageStr('word1617','业主联系电话')}}</span>
					<div class="fR cSub">
						<span :title="basicInfo.contactPhone">{{basicInfo.contactPhone}}</span>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>
<script>
import {getLanguageStr} from '@/util/language.js'
import * as equipmentApi from '@/api/maintain/plant/list'
import Loading from '@/components/common/ui/Loading'
import * as lib from '@/util/lib.js'
export default {
  name: 'stationBasicInfo',
  props:{
	  deviceType: {
		  type:String,
		  default:'plantType,plantGridType,installedCapacity,theoryConsumeProportion,startOperatingTime,startOperatingStatus,contactPhone'
	  }
  },
  components: {Loading},
  data () {
    return {
      stage,
      isLoading: false,
      basicInfo: {},
      metering: []
    }
  },
  methods: {
    getLanguageStr,
    getTypeText: lib.getTypeText,
    floatFix: lib.floatFix,
    convertData: lib.convertData,
    timeFormat: lib.timeFormat,
    show (data){
      this.isLoading = true
      this.basicInfo = data.basicInfo
      this.metering = data.metering
      setTimeout(() => {
        this.isLoading = false
      }, 500)
      // if(data.basicInfo){
      //     this.basicInfo=data.basicInfo
      //     setTimeout(()=>{
      //          this.isLoading=false
      //     },500)
      // }else{
      //     this._getBasicInfo(data.id)
      // }
      // if(data.metering){
      //     this.metering=data.metering
      // }else{
      //     this._getMetering(data.id)
      // }
    },
    // 获取详情-电站信息
    _getBasicInfo (id) {
      this.isLoading = true
      equipmentApi.StationBasicInfo(id).then(response => {
        this.isLoading = false
        this.basicInfo = response
      }, error => {
        !_.isEmpty(error) && this.$notify(error)
      })
    },
    // 获取理论自发自用率
    _getMetering (id) {
      this.isLoading = true
      equipmentApi.StationMetering(id).then(response => {
        this.isLoading = false
        this.metering = response
      }, error => {
        !_.isEmpty(error) && this.$notify(error)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.panel .title{ margin-bottom: 0 }
// .viewBox>li:nth-child(2n+1){
// 	padding-right: 2em
// }
// .viewBox>li:nth-child(2n){
// 	padding-left: 2em
// }
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/detail/StationBasicInfo.vue